import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import dayjs from 'dayjs'

const Campanha = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idAgenda: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlGestaoCampanha" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {localAtendimento !== undefined && localAtendimento !== null && (
              <PrimeTable
                codigo="CtrlGestaoCampanha"
                action="lista"
                rows={10}
                habSearch
                head={[
                  'Título',
                  'Tipo de Envio',
                  'Período',
                  'Pessoas',
                  'Status',
                ]}
                line={(item) => [
                  item?.nmCampanha,
                  item?.tpEnvio,
                  `${item?.dtInicio ? dayjs(item?.dtInicio).format('DD/MM/YYYY') : ''} - ${item?.dtFim ? dayjs(item?.dtFim).format('DD/MM/YYYY') : ''}`,
                  item?.qtPessoas || 0,
                  item?.tpStatus,
                ]}
                onRowSelect={handleClick}
                onDelete={{ index: 5, action: exclui }}
                refresh={refresh}
              />
            )}
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default Campanha
